import axios from "@/plugins/axios";
export default {
  signIn: (data) =>
    axios.post(`/login`, data).then((response) => response.data),
  signUp: (data) =>
    axios.post(`/register`, data).then((response) => response.data),
  me: () => axios.post(`/generator/me`).then((response) => response.data),
  resetPassword: (data) =>
    axios.post(`/generator/reset-password`, data).then((response) => response.data),
  updatePassword: (data) =>
    axios.post(`/auth/update-password`, data).then((response) => response.data),
  emailVerify: (data) =>
    axios.post(`/generator/confirm-email`,data).then((response) => response.data)
};
